var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.section_id,attrs:{"label":item.cname,"value":item.section_id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }